/* Navigate a product card's photos via chevrons. Delegation covers cards
   injected later; the click does not trigger the card link. Images 2-5 are
   data-src and hydrate on card hover or the first chevron click. */
(function () {
  function images(thumb) {
    return thumb.querySelectorAll('.bq-card__img');
  }

  function hydrate(img) {
    if (!img || !img.dataset.src) return;
    if (img.dataset.srcset) img.srcset = img.dataset.srcset;
    img.src = img.dataset.src;
    delete img.dataset.src;
    delete img.dataset.srcset;
  }

  function go(thumb, dir) {
    var list = images(thumb);
    if (list.length < 2) return;
    var current = thumb.bqIndex || 0;
    var next = ((current + dir) % list.length + list.length) % list.length;
    hydrate(list[next]);
    if (list[current]) list[current].classList.remove('is-active');
    list[next].classList.add('is-active');
    thumb.bqIndex = next;
  }

  document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-bq-card-nav]');
    if (!btn) return;
    event.preventDefault();
    event.stopPropagation();
    var thumb = btn.closest('.bq-card__thumb');
    if (thumb) go(thumb, btn.getAttribute('data-bq-card-nav') === 'next' ? 1 : -1);
  });

  // Warm the hovered card's photos (pointerenter does not bubble, so capture).
  document.addEventListener('pointerenter', function (event) {
    if (!(event.target instanceof Element)) return;
    var thumb = event.target.closest('.bq-card__thumb');
    if (!thumb || thumb.dataset.bqHydrated) return;
    thumb.dataset.bqHydrated = '1';
    images(thumb).forEach(hydrate);
  }, true);
})();
